import React, { useState, useEffect, useRef } from 'react'
import { useReactToPrint } from "react-to-print";
import { useSnackbar } from 'react-simple-snackbar'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initialStateInvoice } from '../../initialState'
import { getInvoice } from '../../actions/invoiceActions'
import { toCommas } from '../../utils/utils'
import styles from './InvoiceDetails.module.css'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { Container, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Spinner from '../Spinner/Spinner'
import Modal from '../Payments/Modal'


const InvoiceDetails = () => {

    const location = useLocation()
    const [invoiceData, setInvoiceData] = useState(initialStateInvoice)
    const [ rates, setRates] = useState(0)
    const [vat, setVat] = useState(0)
    const [totalAmount, setTotalAmount] = useState("USD")
    const [subTotal, setSubTotal] = useState(0)
    const [stockPrice, setStockPrice] = useState(0)
    const [total, setTotal] = useState(0)
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState(moment().format('MM/DD/YYYY'));
    const [ client, setClient] = useState(null)
    const [type, setType] = useState('Invoice')
    const [notes, setNotes] = useState('')
    const [status, setStatus ] = useState('')
    const [company, setCompany] = useState({})
    const { id } = useParams()
    const { invoice } = useSelector((state) => state.invoices)
    const dispatch = useDispatch()
    const history = useHistory()
    const [invoiceNumber, setInvoiceNumber] = useState('')
    // eslint-disable-next-line
    const [openSnackbar, closeSnackbar] = useSnackbar()
    const user = JSON.parse(localStorage.getItem('profile'))
    const contentPrint = useRef();


    const handlePrint = () => {
      const printContents = contentPrint.current?.innerHTML;
      if (!printContents) return;
  
      const printWindow = window.open(`/invoiceprint/${id}`, '', 'width=800,height=600');
      
      printWindow.document.close();
      printWindow.focus();
     // printWindow.print();
     // printWindow.close();
    };

    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          '& > *': {
            margin: theme.spacing(1),
          },
        },
        large: {
          width: theme.spacing(12),
          height: theme.spacing(12),
        },
        table: {
            minWidth: 650,
          },
    
        headerContainer: {
            // display: 'flex'
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(1),
            backgroundColor: '#f2f2f2',
            borderRadius: '10px 10px 0px 0px'
        }
      }));
    

    const classes = useStyles()

    useEffect(() => {
        dispatch(getInvoice(id));
      },[id, dispatch, location]);

      useEffect(() => {
        if(invoice) {
            //Automatically set the default invoice values as the ones in the invoice to be updated
            //console.log(invoice)
            setInvoiceData(invoice)
            setInvoiceNumber(invoice.invoiceNumber);
            setClient(invoice.customer[0])            
            setStockPrice(invoice.stockPrice)
            setSelectedDate(invoice.invoiceDate)
            setRates(invoice.taxRate) 
            setNotes(invoice.notes) 
            setTotalAmount(invoice.totalAmount)
            setInvoiceData({...invoiceData, items: invoice.items}) 
            var subtotalAmt = 0;        
            invoiceData.items.map((itemField, index) => (         
              subtotalAmt += itemField.amount      
                
               ))
            setSubTotal(subtotalAmt)
              //VAT is calculated as tax rates /100 * subtotal
            setVat(invoice.taxRate /100 * subtotalAmt)          
          
        }
        
    }, [invoice])

    //Get the total amount paid
    let totalAmountReceived = 0
    for(var i = 0; i < invoice?.paymentRecords?.length; i++) {
        totalAmountReceived += Number(invoice?.paymentRecords[i]?.amountPaid)
    }


  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`)
  }
 
 const iconSize = {height: '18px', width: '18px', marginRight: '10px', color: 'gray'}
 const [open, setOpen ] = useState(false)


  function checkStatus() {
    return totalAmountReceived >= total ? "green"
         : status === "Partial" ? "#1976d2"
         : status === "Paid" ? "green"
         : status === "Unpaid" ? "red"
         : "red";
}


if(!invoice) {
  return (
    <Spinner />
  )
}


    return (
        <div ref={contentPrint} className={styles.PageLayout}>
           {invoice?.creator?.includes(user?.result?.id) && (
            <div className={styles.buttons}>
               

                <button 
                className={styles.btn}  
                onClick={() => editInvoice(invoiceData.id)}
                > 
                <BorderColorIcon style={iconSize} 
                />
                Edit Invoice
                </button>

                <button 
                  // disabled={status === 'Paid' ? true : false}
                  className={styles.btn} 
                  onClick={() => setOpen((prev) => !prev)}> 
                  <MonetizationOnIcon style={iconSize} 
                /> 
                Record Payment
                </button>

            
            </div>
             )}

             
        
            <Modal open={open} setOpen={setOpen} invoice={invoice}/>
            <div className={styles.invoiceLayout}>
        <Container  className={classes.headerContainer}>
        
            <Grid container justifyContent="space-between" >
            {!invoice?.creator?.includes(user?.result.id) ? 
            (
              <Grid item>
              </Grid>
            )
            : (
                <Grid item onClick={() => history.push('/settings')} style={{cursor: 'pointer'}}>
                    {company?.logo ? <img src={company?.logo} alt="Logo" className={styles.logo} /> 
                    :
                    <h2>{company?.name}</h2>
                    }
                </Grid>
            )}
                <Grid item style={{marginRight: 40, textAlign: 'right'}}>
                    <Typography style={{lineSpacing: 1, fontSize: 45, fontWeight: 700, color: 'gray'}} >Invoice</Typography>
                    <Typography variant="overline" style={{color: 'gray'}} >No: {invoiceNumber}</Typography>
                    
                </Grid>
            </Grid >
        </Container>
        <Divider />
        <Container>
            <Grid container justifyContent="space-between" style={{marginTop: '40px'}} >
                <Grid item>
                    {invoice?.creator?.includes(user?.result.id) && (
                      <Container style={{marginBottom: '20px'}}>
                        <Typography variant="overline" style={{color: 'gray'}} gutterBottom>From</Typography>
                        <Typography variant="subtitle2">{invoice?.businessDetails?.data?.data?.businessName}</Typography>
                        <Typography variant="body2">{invoice?.businessDetails?.data?.data?.email}</Typography>
                        <Typography variant="body2">{invoice?.businessDetails?.data?.data?.phoneNumber}</Typography>
                        <Typography variant="body2" gutterBottom>{invoice?.businessDetails?.data?.data?.address}</Typography>
                      </Container>
                    )}
                    <Container>
                        <Typography variant="overline" style={{color: 'gray', paddingRight: '3px'}} gutterBottom>Bill to</Typography>
                        <Typography variant="subtitle2" gutterBottom>{client?.name}</Typography>
                        <Typography variant="body2" >{client?.email}</Typography>
                        <Typography variant="body2" >{client?.phone}</Typography>
                        <Typography variant="body2">{client?.address}</Typography>
                    </Container>
                </Grid>

                <Grid item style={{marginRight: 20, textAlign: 'right'}}>

                    <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Invoice Date</Typography>
                    <Typography variant="body2" gutterBottom>{moment(selectedDate).format("MMM Do YYYY")}</Typography>
                    <Typography variant="overline" gutterBottom>Stock Price</Typography>
                    <Typography variant="h6" gutterBottom>{toCommas(stockPrice)}</Typography>
                </Grid>
            </Grid>
        </Container>

        
            <div>

    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table" style={{width: '100%'}}>
                 <TableHead>
                 <TableRow>
                     <TableCell>Item</TableCell>
                     <TableCell align="right">Weight</TableCell>
                     <TableCell align="left">Desc</TableCell>                
                     <TableCell align="right">Labor</TableCell>
                     <TableCell align="right">Price</TableCell>
                     <TableCell align="right">Amount</TableCell>
                     
                 </TableRow>
                 </TableHead>
                 <TableBody>
                 {invoiceData.items.map((itemField, index) => (
                     <TableRow key={index}>
                     <TableCell  scope="row" style={{width: '20%' }}> 
                       {itemField.metal.metalName}
                      </TableCell>
                     <TableCell align="right">{itemField.weight}  </TableCell>
                     <TableCell alight="left"> {itemField.description}  </TableCell>
                     <TableCell align="right"> {toCommas(itemField.labor)}  </TableCell>
                     <TableCell align="right"> {toCommas(itemField.unitPrice)} </TableCell>
                     <TableCell align="right"> {toCommas(itemField.amount)}  </TableCell>
                     
                     
                     </TableRow>
                 ))}
                 </TableBody>
             </Table>
    </TableContainer>
      <div className={styles.addButton}>              
                </div>
      </div>
        <div className={styles.invoiceSummary}>
            <div className={styles.summary}>Invoice Summary</div>
            <div className={styles.summaryItem}>
                <p>Sub total:</p>
                <h4>{toCommas(subTotal.toFixed(2))}</h4>
            </div>
            <div className={styles.summaryItem} style={{display: 'none'}}>
                <p>VAT(%):</p>
                <h4>{toCommas(vat.toFixed(2))}</h4>
            </div>
            <div className={styles.summaryItem}>
                <p>Total</p>
                <h4 style={{color: "black", fontSize: "18px", lineHeight: "8px"}}> {toCommas(totalAmount)}</h4>
            </div>
            
        </div>

        
        <div className={styles.toolBar} style={{display: 'none'}}>
            <Container >
                <Grid container >
                    <Grid item style={{marginTop: '16px', marginRight: 10}}>
                        <TextField 
                            type="text" 
                            step="any" 
                            name="rates" 
                            id="rates" 
                            value={rates} 
                            placeholder="e.g 10" 
                            label="Tax Rates(%)"
                            disabled
                        />
                    </Grid>
                  
                </Grid>
                
            </Container>
        </div>
         
        <div className={styles.note}>
                        <h4>Notes</h4>
                        <textarea 
                        style={{border: 'solid 1px #d6d6d6', padding: '10px',marginBottom: '20px'}}
                            value={notes}
                            disabled
                        />
                         <button onClick={handlePrint} style={{ marginBottom:'20px',backgroundColor: '#1976d2', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer'}}>
                            Print Invoice
                        </button>
                       </div>
                      
            </div>

              
            
             </div>
    )
}

export default InvoiceDetails
